import { render } from "./RecipientTree.vue?vue&type=template&id=862dc720"
import script from "./RecipientTree.vue?vue&type=script&lang=js"
export * from "./RecipientTree.vue?vue&type=script&lang=js"

import "./RecipientTree.vue?vue&type=style&index=0&id=862dc720&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__